import { backendFetch, BackendError } from "@/lib/backend";
import type { UserLookupResponse } from "@/types/backend";

async function readBodyTextSafe(response: Response): Promise<string> {
  try {
    return await response.text();
  } catch {
    return "";
  }
}

/**
 * Looks up a registered user by email.
 * GET /api/users/lookup?email=...
 * Returns null if no user with that email is registered (404).
 */
export async function lookupUserByEmail(
  email: string
): Promise<UserLookupResponse | null> {
  const response = await backendFetch(
    `/api/users/lookup?email=${encodeURIComponent(email)}`,
    { method: "GET" }
  );

  if (response.ok) {
    return (await response.json()) as UserLookupResponse;
  }

  if (response.status === 404) {
    return null;
  }

  const bodyText = await readBodyTextSafe(response);
  throw new BackendError("Failed to look up user.", {
    status: response.status,
    bodyText,
  });
}
